import React from 'react';
import { cn } from '../../lib/utils';

export const ProgressBar = ({ 
  progress = 0, 
  label = '', 
  showPercentage = true,
  className 
}) => {
  return (
    <div className={cn("w-full", className)}>
      {label && (
        <div className="flex justify-between items-center mb-1">
          <span className="text-xs text-zinc-400">{label}</span>
          {showPercentage && (
            <span className="text-xs text-zinc-500">{Math.round(progress)}%</span>
          )}
        </div>
      )}
      <div className="h-2 bg-zinc-800 rounded-full overflow-hidden">
        <div 
          className="h-full bg-gradient-to-r from-blue-500 to-cyan-500 rounded-full transition-all duration-300"
          style={{ width: `${Math.min(100, Math.max(0, progress))}%` }}
        />
      </div>
    </div>
  );
};

export default ProgressBar;
